// @ts-nocheck

import palette from '../palette';

export const MultiviewBlockAddMatch = {
  background: palette.bluegrey850,
  buttonBackground: palette.bluegrey750,
  buttonBackgroundHover: palette.bluegrey700,
  buttonColor: palette.white,
};

export const Modal = {
  header: {
    backgroundColor: palette.bluegrey925,
    color: palette.white,
  },
  filterButton: {
    backgroundColor: palette.transparent,
    color: palette.neutralgrey200,
    borderColor: palette.neutralgrey700,
  },
  categoryTitle: {
    color: palette.neutralgrey200,
  },
  line: {
    odd: {
      background: palette.bluegrey850,
    },
    even: {
      background: palette.sports, //gradient
    },
    validIconColor: palette.greenwinamax600,
    color: palette.white,
  },
};
